<template>
  <el-dialog
    title="图片上传"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :visible="visible"
    @update:visible="close"
  >
    <el-form label-width="120px">
      <el-form-item label="站点：">{{ device.name }}</el-form-item>

      <el-form-item label="图片：">
        <div class="">
          <el-upload
            action="#"
            name="img"
            list-type="text"
            accept="image/jpeg"
            ref="elUploader"
            :limit="20"
            :auto-upload="false"
            :http-request="uploader"
            :before-upload="beforeAvatarUpload"
            :on-exceed="handleExceed"
            :on-error="onError"
            :on-success="onSuccess"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg文件，不超过5mb
            </div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">
        开始上传
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import path from 'path'
import { uploader as imgUploader } from '@/service/admin/img'
// import { formatDate } from '@/utlis/date'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  props: {
    visible: Boolean,
    deviceId: [Number, String]
  },
  data() {
    return {}
  },
  computed: {
    device() {
      return this.teles.find(t => t.id === this.deviceId)
    }
  },
  methods: {
    close() {
      this.$emit('update:visible')
    },
    async uploader({ file: img }) {
      const filename = img.name.replace(path.extname(img.name), '')
      const createdAt = new Date(filename).getTime() || Date.now()

      const { code } = await imgUploader({
        key: this.device.key,
        companyId: this.companyId,
        createdAt,
        img
      })

      return { code, createdAt }
    },
    submit() {
      this.$refs.elUploader.submit()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    handleExceed() {
      this.$message.error('文件数量超出限制')
    },
    onError(err, file) {
      this.$message.error(`${file.name}上传失败`)
    },
    onSuccess: debounce(function(res, file) {
      let date = moment(res.createdAt)
      if (date.isAfter(date.format('YYYY-MM-DD 08:00:00'))) {
        date = date.add(1, 'day')
      }
      this.$emit('get-day', date.format('YYYY-MM-DD'))
      this.$message.success(`${file.name}上传完成`)
    }, 300)
  }
}
</script>

<style lang="css" scoped>
.img-date {
  position: absolute;
  left: 12px;
  top: 12px;
  color: #fff;
  text-shadow: 2px 2px #000;
}
</style>
